<template>
    <div class="ratingShop">
        <p class="ratingShop__line">
            <span class="ratingShop__topText">{{ dictionary.ratingShop.title }}: {{ dictionary.ratingShop.rating }}</span>
            <span class="stars">
                <span v-for="(rate, index) in new Array(5)" :key="index" class="stars__star">
                    <span
                        class="stars__star__inner"
                        :style="`width: ${Math.round(Math.min(100, Math.max(0, (dictionary.ratingShop.rating - index) * 100)))}%`"
                    />
                </span>
            </span>
        </p>
        <p class="ratingShop__line">
            <span class="ratingShop__recommend">
                <img
                    :alt="dictionary.ratingShop.title"
                    src="/nuxt-assets/images/icons/like.svg"
                    class="ratingShop__img"
                    width="11"
                    height="11"
                />
                {{ dictionary.ratingShop.rating * 20 }}% {{ dictionary.ratingShop.text }}
            </span>
        </p>
    </div>
</template>
<script>
export default {
    props: {
        dictionary: {
            type: Object,
            required: true,
        },
    },
}
</script>
<style lang="scss">
.ratingShop {
    padding: 15px 0;

    @media only screen and (min-width: 576px) {
        padding: 20px 50px;
    }
}

.ratingShop__line {
    text-align: center;
    font-size: 14px;
}

.ratingShop__topText {
    font-weight: 700;
}

.ratingShop__img {
    margin-right: 5px;
    margin-top: -2px;
}

.ratingShop__recommend {
    display: inline-block;
    background: #eff3ed;
    padding: 0 13px;
    height: 26px;
    line-height: 26px;
    color: #567746;
    border-radius: 26px;
    font-weight: 600;
}

.stars {
    background: #fff4e0;
    padding: 2px 12px;
    border-radius: 30px;
    margin-left: 14px;
}

.stars__star {
    width: 12px;
    height: 12px;
    margin: 0 2px;
    position: relative;
    display: inline-block;
    background: transparent url('../icons/star-small-deactivate.svg') no-repeat scroll 50% 50%;
    background-size: auto 100%;
}

.stars__star__inner {
    position: absolute;
    left: 0;
    top: 0;
    height: 12px;
    display: inline-block;
    background: transparent url('../icons/star-small-activate.svg') no-repeat scroll 0 50%;
    background-size: auto 100%;
}
</style>
